'use strict';

;( () => {

	document.addEventListener( 'facetwp-refresh', () => {

		// When a selection is made, update the button text to indicate how many
		// items are selected.
		const facets = document.querySelectorAll( '.facetwp-reveal-button' );

		facets.forEach( ( facet ) => {
			const span          = facet.querySelector( 'span' );
			const facetName     = span.getAttribute( 'data-facetwp' );
			const facetInstance = FWP.facets[ facetName ];

			if ( facetInstance && 0 < facetInstance.length ) {
				span.textContent = `(${ facetInstance.length })`;
				return;
			}

			span.textContent = '';
			return;
		});
	});
})();
